import React from "react";
import PropTypes from 'prop-types';
import cx from "classnames";

import { getStars } from "./getStars";

import "./Stars.scss";
import { Star } from "./Star";

const starCount = 5;

export const Stars = props => {
  const className = cx("stars", props.className);
  const stars = getStars(props.rating, starCount);

  return (
    <div className={className}>
     {stars.map((percentage, index) => (
        <Star key={index} percentage={percentage} />     
      ))}
    </div>
  );
};

Stars.propTypes = {
  rating: PropTypes.number.isRequired,
};